import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface UpdateResolution886ReviewReportParams {
	id: string;
	review_id: string;
	name: string;
	workstation_id: string;
	sector_id: string;
	line_id: string;
	company_id: string;
	organization_id: string;
	employer_id: string;
	evaluator_id: string;
	occupational_doctor_id: string;
	safety_and_hygiene_responsible_id: string;
	workers_number: number;
	symptom_location: string;
	early_manifestation: boolean;
	written_work_procedure: boolean;
	training: boolean;
	worker_list_id: string[];
	file_list_id: string[];
	consolidated?: boolean;
	comment?: string;
	review_comment?: string;
}

const Service = Resolution886ReportService.getInstance();

export const useUpdateResolution886ReviewReport = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: UpdateResolution886ReviewReportParams) => Service.update(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_REPORT_REVIEW]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_RESOLUTION_886]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886]);
			message.success(I18n.get('Report updated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error updating report'));
		}
	});
};
